import React, { useMemo } from 'react';
import { Tabs, Typography, Avatar } from 'antd';
import { TDashboard } from '../../../models/user/Dashboard';
import ChildrenContent from './ChildrenContent';

const { Text } = Typography;

interface DashboardParentProps {
    dashboard: TDashboard | null;
}

const DashboardParent: React.FC<DashboardParentProps> = ({ dashboard }) => {
    const palette = useMemo(
        () => ({
            primary: '#2D9CC9',
            secondary: '#8BBE1E',
            background: 'linear-gradient(135deg, rgba(45,156,201,0.08), rgba(139,190,30,0.05))',
            border: 'rgba(45,156,201,0.16)',
            tab: '#f5f9ff',
            muted: 'rgba(12, 24, 42, 0.64)',
        }),
        []
    );

    const items = useMemo(
        () =>
            (dashboard?.dashboard_children || []).map((dsbChild) => ({
                label: (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                        }}
                    >
                        <Avatar
                            style={{
                                width: 36,
                                height: 36,
                                background: palette.primary,
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: 16,
                            }}
                        >
                            {dsbChild.userapp.personal_info?.firstname?.[0] ?? '?'}
                        </Avatar>
                        <Text strong style={{ margin: 0 }}>
                            {dsbChild.userapp.personal_info?.firstname ?? '-'}
                        </Text>
                    </div>
                ),
                key: String(dsbChild.userapp.id),
                children: <ChildrenContent dashboardChildrenData={dsbChild} palette={palette} />,
            })),
        [dashboard, palette]
    );

    return (
        <div
            style={{
            borderRadius: 32,
            padding: '18px 18px 24px',
                background: palette.background,
                border: `1px solid ${palette.border}`,
                boxShadow: '0 20px 45px rgba(7, 24, 38, 0.12)',
            backdropFilter: 'blur(18px)',
            }}
        >
            <Tabs
                defaultActiveKey={items[0]?.key}
                items={items}
                tabBarGutter={16}
                style={{ marginBottom: 0 }}
                tabBarStyle={{
                    margin: 0,
                }}
                rootClassName="dashboard-parent-tabs"
            />
        </div>
    );
};

export default DashboardParent;
